import React, { useEffect, useMemo, useState } from "react";
import axios from "axios";

const safeNum = (v, fallback = 0) => {
  const n = Number(v);
  return Number.isFinite(n) ? n : fallback;
};

const safeStr = (v, fallback = "") => {
  if (v === null || v === undefined) return fallback;
  const s = String(v).trim();
  return s.length ? s : fallback;
};

const Ledger = ({ userID, startDate, endDate, baseUrl, config }) => {
  const [loading, setLoading] = useState(false);
  const [rows, setRows] = useState([]);

  const getAccountLedgerApi = async () => {
    if (!startDate || !endDate) return;

    try {
      setLoading(true);

      const payload = {
        userid: userID,
        fromDate: startDate,
        toDate: endDate,
      };

      const res = await axios.post(
        `${baseUrl}/api/Transactions/getAccountLedgerV1`,
        payload,
        config
      );

      if (res.data?.responseCode === "00") {
        setRows(Array.isArray(res.data?.response) ? res.data.response : []);
      } else {
        setRows([]);
      }
    } catch (e) {
      console.error(e);
      setRows([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getAccountLedgerApi();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [startDate, endDate, userID]);

  const formattedRows = useMemo(() => {
    return rows.map((r) => ({
      id: safeStr(r.id),
      datevalue: safeStr(r.datevalue),
      last_transaction: safeStr(r.last_transaction),
      opening_bal: safeNum(r.opening_bal).toFixed(2),
      closing_bal: safeNum(r.closing_bal).toFixed(2),
      today_topup: safeNum(r.today_topup).toFixed(2),
      today_refund: safeNum(r.today_refund).toFixed(2),
      payout_today: safeNum(r.payout_today).toFixed(2),
      settlement_today: safeNum(r.settlement_today).toFixed(2),
    }));
  }, [rows]);

  if (loading) {
    return (
      <div className="m-5 p-5 d-flex justify-content-center">
        <div className="loader"></div>
      </div>
    );
  }

  return (
    <table className="table table-hover">
      <thead style={{ borderRadius: "10px" }}>
        <tr
          className="text-center greenColour py-4"
          style={{ borderBottom: "1px solid #ccc" }}
        >
          <th
            className="p-3"
            style={{
              color: "#fff",
              backgroundColor: "rgba(1, 195, 125, 1)",
              borderRadius: "7px 0px 0px 7px",
            }}
          >
            Date
          </th>
          <th className="p-3" style={{ color: "#fff", backgroundColor: "rgba(1, 195, 125, 1)" }}>
            Opening Balance
          </th>
          <th className="p-3" style={{ color: "#fff", backgroundColor: "rgba(1, 195, 125, 1)" }}>
            Closing Balance
          </th>
          <th className="p-3" style={{ color: "#fff", backgroundColor: "rgba(1, 195, 125, 1)" }}>
            Today Topup
          </th>
          <th className="p-3" style={{ color: "#fff", backgroundColor: "rgba(1, 195, 125, 1)" }}>
            Today Refund
          </th>
          <th className="p-3" style={{ color: "#fff", backgroundColor: "rgba(1, 195, 125, 1)" }}>
            Payout Today
          </th>
          <th className="p-3" style={{ color: "#fff", backgroundColor: "rgba(1, 195, 125, 1)" }}>
            Settlement Today
          </th>
          <th
            className="p-3"
            style={{
              color: "#fff",
              backgroundColor: "rgba(1, 195, 125, 1)",
              borderRadius: "0px 7px 7px 0px",
            }}
          >
            Last Transaction
          </th>
        </tr>
      </thead>

      <tbody>
        {formattedRows.length === 0 ? (
          <tr>
            <td colSpan="8" className="text-center py-3">
              No Ledger Records Found for Selected Date !
            </td>
          </tr>
        ) : (
          formattedRows.map((r) => (
            <tr
              key={r.id || `${r.datevalue}-${r.last_transaction}`}
              style={{ borderBottom: "1px solid #DDD", padding: "5px 0px" }}
            >
              <td className="p-3 text-center align-middle">{r.datevalue}</td>
              <td className="p-3 text-center align-middle">₹ {r.opening_bal}</td>
              <td className="p-3 text-center align-middle">₹ {r.closing_bal}</td>
              <td className="p-3 text-center align-middle">₹ {r.today_topup}</td>
              <td className="p-3 text-center align-middle">₹ {r.today_refund}</td>
              <td className="p-3 text-center align-middle">₹ {r.payout_today}</td>
              <td className="p-3 text-center align-middle">₹ {r.settlement_today}</td>
              <td className="p-3 text-center align-middle">{r.last_transaction || "-"}</td>
            </tr>
          ))
        )}
      </tbody>
    </table>
  );
};

export default Ledger;
